// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"53c84155","977":"b839b260"}[chunkId] + ".chunk.js";
};